import axios from "axios";
import { handleJWT, rmStorageAndReload } from "./handleJWT";

const SERVER_URL = `${process.env.REACT_APP_SITEURL}/cefr`;
// const SERVER_URL = `http://localhost:3000/cefr`;

const getWordsByCefrLevelApi = async (data) => {
  try {
    let lang = data["lang"] || "en"
    let level = data["level"]
    const url = `${SERVER_URL}/${lang}/${level}.txt`;
    let token = JSON.parse(localStorage.getItem("token"));
    return await axios.get(url, {
      headers: {
        Accept: "Application/json",
        authorization: `bearer ${token}`,
      },
    });
  } catch (error) {
    if (error["response"]["data"]["message"] == "jwt expired") {
      let sucsess = await handleJWT();
      if (sucsess) {
        return await getWordsByCefrLevelApi(data)
      }
    } else if (error["response"]["data"]["message"] == "jwt malformed") {
      rmStorageAndReload();
    } else if (error["response"]["data"]["message"] == "invalid signature") {
      rmStorageAndReload();
    } else {
      console.error(error)
      throw error
    }
  }
};


export {
  getWordsByCefrLevelApi
};
